import InputField from "../../Components/InputField";
import refreshIcon from "../../Assets/icons/image.png";
import { pincodeValidate } from "../../Utils/validation/validators";

const Captcha = ({ captcha, userCaptcha, setUserCaptcha, refreshCaptcha }) => {
  return (
    <>
      <div className="text-center">
        <div className="d-flex align-items-center">
          <span className="mr-2" style={{ minWidth: "80px" }}>
            {captcha.expression} =
          </span>
          <div className="form-group m-0 mr-2">
            <InputField
              type="text"
              id="captcha-input"
              placeholder="Enter the result"
              value={userCaptcha}
              onChange={(e) => {
                const value = e.target.value;
                if (!value) {
                  setUserCaptcha(value);
                } else if (pincodeValidate(value) === true) {
                  setUserCaptcha(value);
                }
              }}
            />
          </div>
          <button
            type="button"
            className="btn btn-hover"
            onClick={refreshCaptcha}
          >
            <img height={24} width={24} src={refreshIcon} alt="" />
          </button>
        </div>
      </div>
    </>
  );
};

export default Captcha;
